import { AddHoliday } from "../../../components/modelpopup/AddHoliday";
import { useEffect, useState } from "react";
import { Dropdown, Button } from "antd";
import moment from "moment";
import Swal from "sweetalert2";
import Breadcrumbs from "../../../components/Breadcrumbs";
import { deleteHoliday, fetchHolidays } from "../../../Slices/holidaySlice";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { CustomGridTable } from "../../../blueplanitUtils/CustomGridTable";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";


const Holidays = () => {
  const users = useSelector((state) => state.holidayData?.holiday)
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedHoliday, setSelectedHoliday] = useState(null);
  const loginUser = useSelector((state) => state?.loginUserInfo?.loginUserDetails);
  const dispatch = useDispatch();

  const handleEditClick = (record) => {
    setSelectedHoliday(record);
    setIsModalOpen(true);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
    setSelectedHoliday(null);
  };

  useEffect(() => {
    dispatch(fetchHolidays({ department: loginUser?.department, role: loginUser?.role }));
  }, [dispatch]);

  const handleDeleteClick = (record) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to delete this leave record?",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(deleteHoliday({ id: record._id })).unwrap()
          .then(() => {
            dispatch(fetchHolidays({ department: loginUser?.department, role: loginUser?.role }))
            Swal.fire("Deleted!", "The holiday record has been deleted.", "success");
          })
          .catch((err) => {
            console.error("Error updating leave status:", err);
            Swal.fire("Error", `Failed to delete the holiday. Error: ${err.message}`, "error");
          });
      }
    });
  };

  // ✅ Define canManage including HR & Admin
  const canManage =
    loginUser?.role === "Super Admin" ||
    loginUser?.role === "Admin" ||
    loginUser?.department === "HR & Admin";

  const columns = [
    {
      title: "Holiday Name",
      dataIndex: "name",
      render: (text) => <span>{text}</span>,
    },
    {
      title: "Department",
      dataIndex: "department",
      render: (text) => <span>{text}</span>,
    },
    {
      title: "Holiday Date",
      dataIndex: "date",
      render: (text) => {
        const date = moment(text).format("DD/MM/YYYY");
        return <span>{date}</span>;
      },
    },
    {
      title: "Type",
      dataIndex: "type",
      render: (text) => <span>{text || "—"}</span>,
    },
    ...(canManage
      ? [
        {
          title: "Action",
          key: "actions",
          render: (record) => {
            const actionItems = [
              {
                key: "edit",
                label: "Edit",
                onClick: () => handleEditClick(record),
              },
              {
                key: "delete",
                label: "Delete",
                danger: true,
                onClick: () => handleDeleteClick(record),
              },
            ];
            return (
              <Dropdown
                menu={{ items: actionItems }}
                trigger={["click"]}
                icon={<FontAwesomeIcon icon={faChevronDown} />}
              >
                <Button>Actions</Button>
              </Dropdown>
            );
          },
        },
      ]
      : []),
  ];

  // ✅ Departments logic: if HR & Admin, show all; else, only user's department
  const departments =
    loginUser?.department === "HR & Admin"
      ? [...new Set(users.map((u) => u.department))]
      : [loginUser?.department];

  return (
    <>
      <div className="page-wrapper">
        <div className="content container-fluid">
          {canManage && (
            <Breadcrumbs
              subtitle="Holidays"
              modal="#add_holiday"
              name="Add Holiday"
            />
          )}

          <div className="row">
            <div className="col-md-12">
              {departments.map((dept) => (
                <div key={dept} className="mb-5">
                  <h4 className="mb-3">{dept} Holidays</h4>
                  <div className="table-responsive">
                    <CustomGridTable
                      columns={columns}
                      Id="holiday-table"
                      dataSource={users.filter((u) => u.department === dept)}
                      rowKey="_id"
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <AddHoliday
        users={users}
        selectedHoliday={selectedHoliday}
        setSelectedHoliday={setSelectedHoliday}
        isOpen={isModalOpen}
        onClose={handleModalClose}
      />
    </>
  );
};

export default Holidays;
